"use client";
import { useState, useEffect } from "react";
import { User } from "lucide-react";
import { AuthModal } from "../auth-modal/index.js";

export function AuthIconSlot({ size = 20, locale = "ko" }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("login");

  useEffect(() => {
    const a = new URLSearchParams(window.location.search).get("auth");
    if (a === "signup" || a === "login") {
      setTab(a);
      setOpen(true);
    }
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => { setTab("login"); setOpen(true); }}
        aria-label="회원가입/로그인"
        className="p-1 transition-opacity hover:opacity-70"
      >
        <User size={size} />
      </button>
      <AuthModal open={open} onClose={() => setOpen(false)} initialTab={tab} locale={locale} />
    </>
  );
}
